{
  "commonHeader": {
    "upgradeToPro": "Tingkatkan",
    "learnMore": "Pelajari lebih lanjut",
    "AIProductivitySuite": {
      "title": "Rangkaian Produktivitas AI",
      "desc": "Ubah diskusi yang inspiratif menjadi hasil kerja yang mengesankan."
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "Kelola akun organisasi Anda dengan AI",
        "description": "Dapatkan jawaban cerdas untuk pertanyaan akun Anda dan bantuan menavigasi pengaturan.",
        "terms": "Dengan menggunakan fitur beta Zoom, Anda menyetujui {0}",
        "termsText": "Ketentuan Program Beta Zoom"
      },
      "diveDeeper": "Pelajari lebih lanjut",
      "shareFeedback": "Bagikan masukan di {0}",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "Tanyakan tentang akun organisasi Anda",
      "heroInvite": "Bagaimana cara mengundang pengguna baru ke akun saya?",
      "heroGroups": "Bagaimana cara menetapkan pengguna ke grup?",
      "heroRoles": "Bagaimana cara mengelola peran dan izin?"
    },
    "backMainAccount": "Kembali ke akun utama",
    "discoverProducts": "Temukan produk",
    "pricing": "Harga",
    "more": "Lainnya",
    "sidebarExpanded": "diperluas",
    "sidebarCollapsed": "diciutkan",
    "search": "Cari",
    "users": "Pengguna",
    "settings": "Pengaturan akun",
    "navigation": "Navigasi",
    "clear": "Hapus",
    "searchPlaceholderAll": "Cari pengguna, pengaturan akun, atau navigasi",
    "searchPlaceholderUsers": "Cari pengguna atau navigasi",
    "searchPlaceholderSettings": "Cari pengaturan akun atau navigasi",
    "searchPlaceholderNav": "Cari navigasi",
    "searchGuide": "Ketik kata kunci untuk mulai mencari",
    "installOnDesktop": "Instal di desktop",
    "downloadCenter": "Pusat unduhan",
    "getInTouch": "Hubungi kami",
    "featuredProduct": "produk unggulan",
    "logo": {
      "adminCenter": "Pusat admin",
      "subAccount": "Mengelola subakun",
      "externalAccount": "Mengelola akun yang didelegasikan"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "Pelajari selengkapnya",
      "gotIt": "Mengerti"
    },
    "coachMark": {
      "dvsTipsTitle": "Divisi kini tersedia",
      "dvsTipsContent": "Divisi digunakan untuk membuat beberapa instans produk Zoom tertentu dalam akun Anda."
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "Pelajari selengkapnya",
      "gotIt": "Mengerti"
    },
    "coachMark": {
      "extAccountTipsTitle": "Kelola akun eksternal",
      "extAccountTipsContent": "Perlu mengelola akun lain? Cukup kirim permintaan—setelah disetujui, Anda langsung bisa mengaksesnya!"
    }
  },
  "feedback": {
    "dialogTitle": "Berikan Umpan Balik",
    "itemLableForProductArea": "Area Produk",
    "itemLableForSatisfied": "Seberapa puaskah Anda dengan pengalaman Anda?",
    "dissatisfied": "Sangat Tidak Puas",
    "satisfied": "Sangat Puas",
    "itemLableForFeedback": "Umpan Balik",
    "placeholder": "Terima kasih atas ide, komentar, dan saran Anda.",
    "btnCancel": "Batal",
    "btnSubmit": "Kirim",
    "supportTips": "Untuk dukungan teknis, kunjungi",
    "btnSupport": "Dukungan.",
    "messages": {
      "success": "Terima kasih atas umpan balik Anda!",
      "productFailed": "Area Produk diperlukan.",
      "scoreFailed": "Skor kepuasan diperlukan."
    },
    "products": {
      "General": "Umum",
      "AI": "AI",
      "Apps": "Aplikasi",
      "Calendar": "Kalender",
      "Clips": "Clips",
      "ContactCenter": "Contact Center",
      "Docs": "Docs",
      "Huddles": "Huddles",
      "Mail": "Mail",
      "Meetings": "Rapat",
      "Notes": "Catatan",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "Penjadwal",
      "Tasks": "Tugas",
      "TeamChat": "Obrolan tim",
      "WebinarsAndEvents": "Webinar dan acara",
      "Whiteboard": "Papan tulis",
      "WorkflowAutomations": "Otomatisasi alur kerja",
      "WorkspaceReservation": "Reservasi ruang kerja",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "Penafian ini dibuat oleh admin akun Anda.",
    "cancel": "Batal",
    "agree": "Setuju"
  },
  "shared": {
    "sideMenu": {
      "personal": "Pribadi",
      "admin": "Admin",
      "menu": "Menu",
      "pinned": "Disematkan",
      "pin": "Sematkan",
      "unpin": "Lepaskan sematan",
      "moveItem": "Pindahkan item",
      "myAccount": "Akun saya",
      "upgradeToPro": "Tingkatkan ke Pro",
      "grabbedKeyboard": "{0} dipegang. Gunakan tombol panah atas dan bawah untuk memindahkan, spasi atau Enter untuk meletakkan.",
      "dropped": "{0} diletakkan.",
      "releasedUnchanged": "{0} dilepaskan, posisi tidak berubah.",
      "movedToPosition": "{0} dipindahkan ke posisi {1} dari {2}.",
      "movedUp": "{0} dipindahkan ke atas, posisi {1} dari {2}.",
      "movedDown": "{0} dipindahkan ke bawah, posisi {1} dari {2}.",
      "movedUpNew": "{0} dipindahkan ke atas, posisi baru {1} dari {2}",
      "movedDownNew": "{0} dipindahkan ke bawah, posisi baru {1} dari {2}",
      "cannotMoveFurther": "{0} tidak dapat dipindahkan lebih jauh.",
      "grabbedMouse": "{0} dipegang. Gerakkan mouse untuk mengubah posisi, klik untuk meletakkan, tekan Escape untuk membatalkan."
    },
    "item": "Item",
    "gotIt": "Mengerti",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "Nomor telepon berhasil ditambahkan! Anda kini dapat menggunakannya untuk proses masuk dan pemulihan akun mendatang.",
    "mfa_to_signin_phone_success": "{phone} sekarang menjadi nomor masuk untuk {email}.",
    "login_passkey_bound_success": "Kunci sandi berhasil dibuat"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "Fitur manajemen lanjutan berikut hanya akan berlaku untuk pengguna berlisensi dan kolaborasi",
      "licensed_basic": "Fitur manajemen lanjutan berikut hanya akan berlaku untuk pengguna berlisensi dan dasar",
      "licensed": "Fitur manajemen lanjutan berikut hanya akan berlaku untuk pengguna berlisensi"
    },
    "support": "- Didukung dalam pengaturan akun dan pengaturan grup pengguna",
    "archive_product": {
      "title": "Arsipkan rapat dan webinar",
      "detail": "- Rapat akan diarsipkan saat pengguna di akun Anda bergabung. Untuk menggunakan pengaturan ini, instal <a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">aplikasi pengarsipan</a> dari Zoom App Marketplace."
    },
    "restrict": {
      "title": "Batasi pengguna dari penggunaan fitur yang dipilih saat mereka bergabung ke rapat",
      "detail": "- Fitur yang dipilih tidak dapat digunakan meskipun host rapat mengaktifkannya untuk rapat."
    },
    "meeting_integration": {
      "title": "Aktifkan integrasi DLP (Pencegahan Kehilangan Data) obrolan dalam rapat",
      "detail": "- Saat diaktifkan, DLP akan diterapkan ke pesan obrolan publik dan privat yang dikirim peserta. Pesan akan langsung dihapus jika peserta rapat (internal/eksternal) mengobrol dan sebuah pesan bertentangan dengan kebijakan kepatuhan organisasi host."
    },
    "chat_tool": {
      "title": "Alat etika obrolan",
      "detail": "- Kenali kata kunci dan pola teks yang ditentukan dalam konten yang dibagikan, dan cegah pengguna agar tidak dengan sengaja membagikan pesan yang tidak diinginkan."
    },
    "information_barriers": {
      "title": "Penghalang informasi",
      "detail": "- Penghalang informasi mengontrol komunikasi antara pengguna tertentu untuk tujuan kepatuhan. Pembatasan pada rapat dan obrolan dapat ditempatkan antara pengguna dalam dua grup dan pada pengguna tertentu dari penggunaan fitur spesifik (mis., obrolan dalam rapat, berbagi layar, dan transfer file). Pembatasan ini mencegah informasi rahasia dipertukarkan di antara pengguna yang tidak sah."
    },
    "dashboard": {
      "title": "Dasbor",
      "detail": "- Untuk rapat > dasbor rapat sebelumnya, untuk beberapa pengguna data yang ditampilkan hanya dalam rentang 3 bulan"
    },
    "reports": {
      "title": "Laporan",
      "detail": "- Beberapa laporan pengguna hanya menampilkan data dalam rentang 3 bulan untuk beberapa pengguna: laporan penafian, laporan log peserta, laporan log aktivitas admin, dan laporan masuk/keluar"
    },
    "close": "Tutup"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "{planName} Anda akan dibatalkan pada {cancelDate}. Sebelum tanggal tersebut, Anda dapat mengaktifkan kembali lisensi webinar Anda. Dari {supportStartDate} - {supportEndDate}, Anda dapat menghubungi Dukungan Pelanggan untuk mendapatkan data webinar yang ada. Setelah {dataLossDate}, Anda akan kehilangan semua data webinar.",
            "nonAdmin": "{planName} Anda akan dibatalkan pada {cancelDate}. Pada tanggal tersebut, Anda dapat menghubungi admin akun untuk mengaktifkan kembali lisensi webinar Anda. Selama {supportStartDate} - {supportEndDate}, Anda dapat menghubungi Dukungan Pelanggan untuk mendapatkan data webinar saat ini. Setelah {dataLossDate}, Anda akan kehilangan semua data webinar akun Anda."
          },
          "admin": "{planName} Anda akan dibatalkan pada {cancelDate}. Pada tanggal tersebut, Anda dapat mengaktifkan kembali lisensi webinar Anda. Selama {supportStartDate} - {supportEndDate}, Anda dapat menghubungi dukungan pelanggan untuk mendapatkan {supportContent} webinar saat ini. Setelah {dataLossDate}, Anda akan kehilangan semua data webinar akun Anda.",
          "nonAdmin": "{planName} Anda akan dibatalkan pada {cancelDate}. Pada tanggal tersebut, Anda dapat menghubungi admin akun untuk mengaktifkan kembali lisensi webinar Anda. Selama {supportStartDate} - {supportEndDate}, Anda dapat menghubungi dukungan pelanggan untuk mendapatkan {supportContent} webinar saat ini. Setelah {dataLossDate}, Anda akan kehilangan semua data webinar akun Anda."
        },
        "expired": {
          "admin": "{planName} Anda dibatalkan. Selama {supportStartDate} - {supportEndDate}, Anda dapat menghubungi Dukungan Pelanggan untuk mendapatkan {supportContent} webinar saat ini atau membeli Zoom Webinars lagi untuk memulihkan akses data. Setelah {dataLossDate}, Anda akan kehilangan semua data webinar akun Anda.",
          "nonAdmin": "{planName} Anda dibatalkan. Selama {supportStartDate} - {supportEndDate}, Anda dapat menghubungi Dukungan Pelanggan untuk mendapatkan {supportContent} webinar saat ini, atau menghubungi admin akun untuk membeli Zoom Webinars lagi untuk memulihkan akses data. Setelah {dataLossDate}, Anda akan kehilangan semua data webinar akun Anda."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "{planName} Anda akan dijeda pada {pausedDate} selama {pauseDuration}. Selama periode jeda, Anda hanya dapat melihat webinar saat ini dan asetnya. Anda dipersilakan untuk menghapus jeda dan melanjutkan langganan lisensi webinar Anda kapan saja.",
            "nonAdmin": "{planName} Anda akan dijeda pada {pausedDate} selama {pauseDuration}. Selama periode jeda, Anda hanya dapat melihat webinar saat ini dan asetnya. Anda dapat menghubungi admin akun Anda untuk menghapus jeda dan melanjutkan langganan lisensi webinar Anda kapan saja."
          },
          "admin": "{planName} Anda akan dijeda pada {pausedDate} selama {pauseDuration}. Selama periode jeda, Anda hanya dapat melihat {supportContent}. Anda dipersilakan untuk menghapus jeda dan melanjutkan langganan lisensi webinar Anda kapan saja.",
          "nonAdmin": "{planName} Anda akan dijeda pada {pausedDate} selama {pauseDuration}. Selama periode jeda, Anda hanya dapat melihat {supportContent}. Anda dapat menghubungi admin akun untuk menghapus jeda dan melanjutkan langganan lisensi webinar Anda kapan saja."
        },
        "active": {
          "webinars": {
            "admin": "{planName} Anda dijeda selama {pauseDuration} mulai {pausedDate}. Selama jeda, Anda hanya dapat melihat webinar saat ini. Anda dipersilakan melanjutkan langganan lisensi webinar Anda kapan saja.",
            "nonAdmin": "{planName} Anda dijeda selama {pauseDuration} mulai {pausedDate}. Selama jeda, Anda hanya dapat melihat webinar saat ini. Anda dipersilakan untuk menghubungi admin akun untuk melanjutkan langganan lisensi webinar Anda kapan saja."
          },
          "admin": "{planName} Anda dijeda selama {pauseDuration}. Selama jeda, Anda hanya dapat melihat {supportContent} webinar saat ini. Anda dipersilakan melanjutkan langganan lisensi webinar Anda kapan saja.",
          "nonAdmin": "{planName} Anda dijeda selama {pauseDuration}. Selama jeda, Anda hanya dapat melihat {supportContent} webinar saat ini. Anda dipersilakan untuk menghubungi admin akun untuk melanjutkan langganan lisensi webinar Anda kapan saja."
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "Lisensi {planName} Anda akan dijeda pada {pausedDate} selama {pauseDuration}. Untuk terus menyelenggarakan webinar, tetapkan lisensi aktif kepada pengguna ini sebelum jeda mulai berlaku. Anda juga dapat menghapus jeda untuk terus menggunakan lisensi ini.",
            "nonAdmin": "Lisensi {planName} Anda akan dijeda pada {pausedDate} selama {pauseDuration}. Selama periode jeda, Anda hanya dapat melihat webinar saat ini dan asetnya. Untuk terus menyelenggarakan webinar, hubungi admin akun Anda untuk menetapkan lisensi aktif ke akun Anda sebelum jeda berlaku."
          },
          "active": {
            "admin": "Lisensi {planName} Anda dijeda selama {pauseDuration} mulai {pausedDate}. Selama jeda, Anda hanya dapat melihat webinar saat ini. Anda dipersilakan untuk melanjutkan langganan lisensi atau menetapkan lisensi aktif ke akun Anda untuk terus menyelenggarakan webinar.",
            "nonAdmin": "Lisensi {planName} Anda dijeda selama {pauseDuration} mulai {pausedDate}. Selama jeda, Anda hanya dapat melihat webinar saat ini. Untuk menyelenggarakan webinar selama jeda, silakan hubungi admin akun Anda untuk menetapkan lisensi aktif ke akun Anda."
          }
        },
        "cancel": {
          "active": {
            "admin": "Lisensi {planName} Anda akan dibatalkan pada {cancelDate}. Untuk terus menyelenggarakan webinar, aktifkan kembali lisensi webinar Anda atau tetapkan lisensi aktif sebelum pembatalan berlaku. Jika tidak ada tindakan yang diambil, Anda akan memiliki masa tenggang dari {supportStartDate} - {supportEndDate} untuk menghubungi Dukungan Pelanggan guna mengambil data webinar yang ada. Setelah {dataLossDate}, semua data webinar yang terkait dengan akun Anda akan dihapus secara permanen.",
            "nonAdmin": "Lisensi {planName} Anda akan dibatalkan pada {cancelDate}. Untuk terus menyelenggarakan webinar, hubungi admin akun Anda untuk mengaktifkan kembali lisensi webinar atau menetapkan lisensi aktif sebelum pembatalan berlaku. Jika tidak ada tindakan yang diambil, Anda akan memiliki masa tenggang dari {supportStartDate} - {supportEndDate} untuk menghubungi Dukungan Pelanggan guna mengambil data webinar yang ada. Setelah {dataLossDate}, semua data webinar yang terkait dengan akun Anda akan dihapus secara permanen."
          },
          "expired": {
            "admin": "Lisensi {planName} Anda telah dibatalkan. Untuk terus menyelenggarakan webinar, tetapkan lisensi aktif kepada pengguna ini. Dari {supportStartDate} - {supportEndDate}, Anda dapat menghubungi Dukungan Pelanggan untuk mendapatkan data webinar yang ada.",
            "nonAdmin": "Lisensi {planName} Anda telah dibatalkan. Untuk terus menyelenggarakan webinar, silakan hubungi admin akun Anda untuk menetapkan lisensi aktif ke profil Anda. Dari {supportStartDate} - {supportEndDate}, hubungi Dukungan Pelanggan untuk mengambil data webinar yang ada."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "Lisensi {planName} Anda akan dijeda pada {pausedDate} selama {pauseDuration}. Selama periode jeda, Anda hanya dapat melihat {supportContent} webinar sebelumnya. Untuk terus mengakses aset webinar, tetapkan lisensi aktif kepada pengguna ini sebelum jeda mulai berlaku. Anda juga dapat menghapus jeda untuk terus menggunakan lisensi ini.",
              "nonAdmin": "Lisensi {planName} Anda akan dijeda pada {pausedDate} selama {pauseDuration}. Selama periode jeda, Anda hanya dapat melihat {supportContent}. Untuk terus mengakses aset webinar, silakan hubungi admin akun Anda untuk menetapkan lisensi aktif ke profil Anda."
            },
            "active": {
              "admin": "{planName} Anda dijeda selama {pauseDuration} mulai {pausedDate}. Selama jeda, Anda hanya dapat melihat {supportContent} webinar yang ada. Untuk terus mengakses aset webinar, harap tetapkan lisensi aktif ke akun Anda. Anda juga dapat melanjutkan langganan lisensi ini kapan saja.",
              "nonAdmin": "{planName} Anda dijeda selama {pauseDuration} mulai {pausedDate}. Selama jeda, Anda hanya dapat melihat {supportContent} webinar yang ada. Untuk menyelenggarakan webinar selama jeda, silakan hubungi admin akun Anda untuk menetapkan lisensi aktif ke akun Anda."
            }
          },
          "cancel": {
            "active": {
              "admin": "{planName} Anda akan dibatalkan pada {cancelDate}. Untuk terus menyelenggarakan webinar, harap tetapkan lisensi aktif ke akun Anda sebelum pembatalan berlaku. Anda dapat mengaktifkan kembali lisensi ini sebelum {cancelDate}. Dari {supportStartDate} - {supportEndDate}, Anda dapat menghubungi Dukungan Pelanggan untuk mendapatkan {supportContent} webinar yang ada.",
              "nonAdmin": "Lisensi {planName} Anda akan dibatalkan pada {cancelDate}. Untuk terus menyelenggarakan webinar, hubungi admin akun Anda untuk mengaktifkan kembali lisensi webinar atau menetapkan lisensi aktif sebelum pembatalan berlaku. Jika tidak ada tindakan yang diambil, Anda akan memiliki masa tenggang dari {supportStartDate} - {supportEndDate} untuk menghubungi Dukungan Pelanggan guna mengambil {supportContent} webinar yang ada. Setelah {dataLossDate}, semua data webinar yang terkait dengan akun Anda akan dihapus secara permanen."
            },
            "expired": {
              "admin": "Lisensi {planName} Anda telah dibatalkan. Untuk terus menyelenggarakan webinar, tetapkan lisensi aktif kepada pengguna ini. Dari {supportStartDate} hingga {supportEndDate}, hubungi Dukungan Pelanggan untuk mendapatkan {supportContent} webinar yang ada.",
              "nonAdmin": "Lisensi {planName} Anda telah dibatalkan. Untuk terus menyelenggarakan webinar, silakan hubungi admin akun Anda untuk menetapkan lisensi aktif ke profil Anda. Dari {supportStartDate} hingga {supportEndDate}, hubungi Dukungan Pelanggan untuk mendapatkan {supportContent} webinar yang ada."
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "data",
        "recordingsAndTranscripts": "rekaman dan transkrip",
        "reports": "laporan",
        "summaries": "ringkasan",
        "dashboard": "dasbor"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "Rekaman & Transkrip webinar sebelumnya",
          "reports": "laporan webinar sebelumnya",
          "summaries": "ringkasan webinar sebelumnya",
          "dashboard": "dasbor webinar sebelumnya",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "Aktifkan kembali paket",
    "purchasePlan": "Beli paket",
    "removePause": "Hapus jeda",
    "resumeSubscription": "Lanjutkan langganan",
    "month": "bulan",
    "months": "bulan",
    "assignLicense": "Tetapkan Lisensi"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "Mengerti"
    },
    "coachMark": {
      "tipsTitle": "Buku Alamat akan menjadi Direktori Pelanggan",
      "tipsContent": "Pada rilis Oktober 2026, kami mengganti nama Buku Alamat menjadi Direktori Pelanggan agar lebih mencerminkan tujuannya. Semua fungsi, izin, dan alur kerja yang ada akan tetap sama—Anda akan terus mengelola daftar pelanggan (buku alamat) dan kontak seperti yang Anda lakukan saat ini."
    }
  },
  "zoomPrivacy": {
    "agreeMain": "Kami memperbarui persyaratan dan kebijakan kami",
    "agreeSub": "Dengan tetap menggunakan Zoom, Anda menerima <a href=\"https://www.zoom.us/terms\" target=\"_blank\">Ketentuan Layanan</a> dan <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">Kebijakan Privasi</a> yang baru.",
    "continue": "Lanjutkan"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "Kembali ke akun utama",
      "backLinkedAccount": "Kembali ke akun tertaut",
      "backMyAccount": "Kembali ke Akun Saya",
      "myAccount": "Akun saya"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "Custom AI Companion kini tersedia untuk akun Anda",
      "desc": "Berikut beberapa fitur Custom AI Companion yang dapat Anda gunakan di akun Anda:",
      "studioTitle": "AI Studio",
      "studioDesc": "Sesuaikan pengalaman AI Companion untuk organisasi Anda.",
      "integrationsTitle": "Integrasi pihak ketiga",
      "integrationsDesc": "Manfaatkan aplikasi pihak ketiga untuk merampingkan alur kerja Anda.",
      "clipsTitle": "Avatar kustom untuk Zoom Clips",
      "clipsDesc": "Izinkan pengguna mempersonalisasi avatar AI untuk digunakan dalam klip mereka."
    },
    "coachMark": {
      "licenseTitle": "Anda memiliki {0} lisensi Custom AI Companion untuk ditetapkan",
      "licenseDesc": "Tetapkan lisensi ini di bawah <b>Manajemen Pengguna</b> agar pengguna Anda dapat mulai menggunakan kemampuan AI Companion tingkat lanjut.",
      "settingTitle": "Lihat pengaturan Custom AI Companion untuk akun Anda",
      "settingDesc": "Konfigurasikan pengaturan untuk setiap fitur Custom AI di bawah <b>Pengaturan Akun</b>. <a href=\"/account/setting?tab=aicompanion\">Buka pengaturan</a>",
      "groupSettingTitle": "Lihat pengaturan Custom AI untuk grup Anda",
      "groupSettingDesc": "Konfigurasikan pengaturan untuk setiap fitur Custom AI di bawah <b>Pengaturan Grup</b>. <a href=\"/account/group\">Buka pengaturan</a>"
    },
    "common": {
      "learnMore": "Pelajari lebih lanjut",
      "quickTour": "Ikuti tur singkat",
      "remindLater": "Ingatkan saya nanti",
      "dismiss": "Tutup",
      "next": "Berikutnya",
      "back": "Kembali",
      "gotIt": "Mengerti",
      "goToSetting": "Buka pengaturan"
    },
    "aiPanelToast": "Aktifkan pengaturan <b>Panel AI di Zoom Workplace</b> untuk mulai menggunakan semua fitur Custom AI Companion."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "Mengerti",
      "next": "Berikutnya",
      "remindMeLater": "Ingatkan saya nanti",
      "waffleMenuTitle": "Selamat datang di pengalaman web Zoom yang baru",
      "waffleMenuDesc": "Akses produk Zoom dari mana pun Anda berada dengan <b>menu produk.</b>",
      "profileMenuTitle": "Akun Saya",
      "profileMenuDesc": "Temukan profil dan pengaturan pribadi Anda di <b>Akun Saya.</b>",
      "personalTitle": "Akses semua yang Anda butuhkan",
      "personalDesc": "<b>Akun Saya</b> mencakup profil, pengaturan, transkrip rapat, dan lainnya.",
      "adminCenterTitle": "Temukan pengaturan organisasi di Pusat Admin",
      "adminCenterDesc": "<b>Pusat Admin</b> baru Anda memungkinkan Anda mengonfigurasi produk dan menyesuaikan pengaturan untuk seluruh organisasi.",
      "adminMenuForTitle": "Gunakan Pusat Admin seperti profesional",
      "adminMenuForAccountSettings": "<b>Pengaturan</b> memungkinkan Anda mengakses pengaturan produk default untuk semua orang di organisasi Anda.",
      "adminMenuForContentManagementItem": "<b>Manajemen konten</b> adalah tempat Anda dapat mengelola semua konten yang dibuat pengguna.",
      "adminMenuForConfigureProductsItem": "<b>Konfigurasi produk</b> memungkinkan Anda menyiapkan dan menyelesaikan tugas admin untuk produk Anda.",
      "adminMenuForNoItems": "Pusat admin baru memudahkan Anda mengakses dan mengelola pengaturan akun serta produk. Anda juga dapat menyematkan item apa pun untuk akses yang lebih cepat.",
      "tryNewExperience": "Coba pengalaman baru",
      "tryNewExperienceDetail": "Cobalah! Anda selalu dapat kembali ke pengalaman klasik ini.",
      "tryNewExperienceTitle": "Tampilan baru untuk Zoom Web!"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. Hak cipta dilindungi undang-undang.",
    "terms": "Ketentuan",
    "privacy": "Privasi",
    "trust_center": "Pusat Kepercayaan",
    "acceptable_use_guidelines": "Pedoman Penggunaan yang Dapat Diterima",
    "legal": "Hukum",
    "do_not_sell_my_personal_information": "Pilihan Privasi Anda",
    "cookie_preferences": "Preferensi Cookie",
    "pricing": "Paket & Harga",
    "feedback": "Umpan Balik",
    "contact_us": "Hubungi Kami"
  },
  "termChange": {
    "changeTerm": {
      "title": "Perjanjian Perubahan Jangka Waktu Perpanjangan",
      "quoteNumbers": "Formulir Pesanan yang Dimodifikasi - {0}",
      "content1": "Dengan menerima ketentuan ini, Pelanggan setuju untuk mengubah jangka waktu perpanjangan langganan yang ada untuk semua Formulir Pesanan antara Zoom Communications, Inc. (“Zoom”) dan Pelanggan dengan mengubah jangka waktu komitmen dari perpanjangan bulanan menjadi {0}. Sebagai imbalan atas komitmen ini, Zoom setuju untuk mempertahankan harga Pelanggan saat ini selama jangka waktu perpanjangan baru yang pertama.",
      "content2": "Pelanggan memahami bahwa jangka waktu perpanjangan baru sebesar {0} berlaku setelah Pelanggan mengklik “Saya menerima” di bawah, dan bahwa jangka waktu perpanjangan baru akan dimulai pada hari setelah berakhirnya jangka waktu perpanjangan bulanan Pelanggan saat ini. Jangka waktu perpanjangan baru ini akan berlaku untuk semua Formulir Pesanan yang saat ini berlaku dengan Zoom, dan semua jangka waktu perpanjangan di masa mendatang berdasarkan Formulir Pesanan ini akan memiliki panjang jangka waktu yang sama.",
      "content3": "Pelanggan mengakui bahwa satu-satunya perubahan yang dilakukan adalah pada jangka waktu perpanjangan, dan bahwa semua ketentuan dan syarat lainnya dari setiap Formulir Pesanan yang saat ini berlaku dengan Zoom tetap tidak berubah serta berlaku penuh sesuai dengan ketentuannya.",
      "content4": "Anda juga setuju bahwa ini merupakan komitmen kontraktual antara Pelanggan dan Zoom.",
      "agreementText": "Dengan mengklik “Saya menerima”, Anda menyatakan bahwa Anda berwenang untuk membuat perubahan ini atas nama Pelanggan, dan bahwa Pelanggan menyetujui syarat dan ketentuan yang diuraikan di atas.",
      "IDecline": "Saya menolak",
      "IAccept": "Saya menerima"
    },
    "unableToChangeTerm": {
      "title": "Tidak dapat mengubah jangka waktu perpanjangan",
      "content": "Akun Anda tidak memenuhi syarat untuk memperbarui jangka waktu perpanjangan. <a target=\"_blank\" href=\"{0}\">Hubungi kami</a> jika ini adalah kesalahan.",
      "acceptedTitle": "Jangka Waktu Perpanjangan Diperpanjang",
      "acceptedContent": "Anda telah menerima ketentuan perpanjangan sebelumnya. Tidak ada tindakan lebih lanjut yang diperlukan.",
      "GotIt": "Mengerti"
    },
    "termLengthUpdated": "Panjang jangka waktu perpanjangan diperbarui menjadi {0} bulan.",
    "termLengthUnchanged": "Panjang jangka waktu tidak berubah.",
    "errorInfo": "Terjadi kesalahan server. Coba lagi.",
    "x12MonthTerm": "jangka waktu dua belas (12) bulan",
    "x24MonthTerm": "jangka waktu dua puluh empat (24) bulan",
    "x12MonthTermPlural": "dua belas (12) bulan",
    "x24MonthTermPlural": "dua puluh empat (24) bulan"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "Akun Anda dijadwalkan diperbarui ke <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">pengalaman web Zoom yang baru</a> pada {0}.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">Tinjau kapan harus memperbarui</a>"
    },
    "completed": {
      "content": "Pengalaman web Zoom yang baru kini aktif untuk semua pengguna di akun Anda. Pengguna akan melihat antarmuka yang diperbarui saat masuk berikutnya."
    }
  }
}
